import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHeartRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.026 19.617s-5.41-4.998-6.353-6.235C3.731 12.145 3 11.15 3 9.33a5.025 5.025 0 0 1 8.578-3.555l.422.422.422-.422A5.026 5.026 0 0 1 21 9.33c0 1.821-.731 2.816-1.673 4.053-.943 1.238-6.353 6.235-6.353 6.235a1.427 1.427 0 0 1-1.948 0Z"
    />
  </svg>
);
const Memo = memo(SvgIconHeartRoundFill);
export default Memo;
